"use client"

import { memo } from "react"
import { catColor } from "@/lib/catColors"

const PageHeader = ({
	title,
	description,
	eyebrow,
	stats,
	accentName = "All",
	className = "",
}) => {
	const accent = catColor(accentName)

	return (
		<header
			className={`min-w-0 w-full pb-4 mb-5 border-b-4 ${className}`}
			style={{ borderColor: accent }}
		>
			{eyebrow && (
				<p className="mr text-[11px] font-bold tracking-widest uppercase text-(--text-tertiary) mb-2">
					{eyebrow}
				</p>
			)}

			<h1 className="mr m-0 text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold leading-tight tracking-tight text-(--text-primary) break-words [overflow-wrap:anywhere]">
				{title}
			</h1>

			{description && (
				<p className="mr mt-3 mb-0 text-[clamp(0.9rem,1.2vw,1.05rem)] leading-relaxed text-(--text-secondary) max-w-3xl break-words [overflow-wrap:anywhere]">
					{description}
				</p>
			)}

			{stats && (
				<div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-3.5 text-[13px] text-(--text-tertiary)">
					{stats}
				</div>
			)}
		</header>
	)
}

export default memo(PageHeader)
